// Scroll Masks Animation (ES Module)
// Uses global gsap, ScrollTrigger, SplitText, and Lenis from window object

document.addEventListener("DOMContentLoaded", async () => {
     if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('⚠️ Scroll Masks: GSAP or ScrollTrigger not loaded');
          return;
     }
     
     gsap.registerPlugin(ScrollTrigger, SplitText);

     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     const spotlightImages = document.querySelector(".scroll-masks-spotlight-images");
     const maskContainer = document.querySelector(".scroll-masks-mask-container");
     const maskImage = document.querySelector(".scroll-masks-mask-img");
     const maskHeader = document.querySelector(".scroll-masks-mask-container .scroll-masks-header h1");

     if (!spotlightImages || !maskContainer || !maskImage) {
          console.log("Scroll masks animation elements not found");
          return;
     }

     let headerSplit = null;
     let currentScrollTrigger = null;

     try {
          if (document.fonts && document.fonts.ready) {
               await document.fonts.ready;
          }
     } catch (e) { }

     function initScrollMasksAnimation() {
          const spotlightContainerHeight = spotlightImages.offsetHeight;
          const viewportHeight = window.innerHeight;
          const initialOffset = spotlightContainerHeight * 0.05;
          const totalMovement =
               spotlightContainerHeight + initialOffset + viewportHeight;

          if (!headerSplit && maskHeader) {
               headerSplit = SplitText.create(maskHeader, {
                    type: "words",
                    wordsClass: "spotlight-word",
               });
               gsap.set(headerSplit.words, { opacity: 0 });
          }

          if (currentScrollTrigger) {
               currentScrollTrigger.kill();
          }

          currentScrollTrigger = ScrollTrigger.create({
               trigger: ".scroll-masks-spotlight",
               start: "top top",
               end: `+=${window.innerHeight * 7}px`,
               pin: true,
               pinSpacing: true,
               scrub: 1,
               onUpdate: (self) => {
                    const progress = self.progress;

                    if (progress <= 0.5) {
                         const imagesMoveProgress = progress / 0.5;

                         const startY = 5;
                         const endY = -(totalMovement / spotlightContainerHeight) * 100;
                         const currentY = startY + (endY - startY) * imagesMoveProgress;

                         gsap.set(spotlightImages, {
                              y: `${currentY}%`,
                         });
                    }

                    if (maskContainer && maskImage) {
                         if (progress >= 0.25 && progress <= 0.75) {
                              const maskProgress = (progress - 0.25) / 0.5;
                              const maskSize = `${maskProgress * 450}%`;
                              const imageScale = 1.5 - maskProgress * 0.5;

                              maskContainer.style.setProperty("-webkit-mask-size", maskSize);
                              maskContainer.style.setProperty("mask-size", maskSize);

                              gsap.set(maskImage, {
                                   scale: imageScale,
                              });
                         } else if (progress < 0.25) {
                              maskContainer.style.setProperty("-webkit-mask-size", "0%");
                              maskContainer.style.setProperty("mask-size", "0%");
                              gsap.set(maskImage, {
                                   scale: 1.5,
                              });
                         } else if (progress > 0.75) {
                              maskContainer.style.setProperty("-webkit-mask-size", "450%");
                              maskContainer.style.setProperty("mask-size", "450%");
                              gsap.set(maskImage, {
                                   scale: 1,
                              });
                         }
                    }

                    if (headerSplit && headerSplit.words.length > 0) {
                         if (progress >= 0.75 && progress <= 0.95) {
                              const textProgress = (progress - 0.75) / 0.2;
                              const totalWords = headerSplit.words.length;

                              headerSplit.words.forEach((word, index) => {
                                   const wordRevealProgress = index / totalWords;

                                   if (textProgress >= wordRevealProgress) {
                                        gsap.set(word, { opacity: 1 });
                                   } else {
                                        gsap.set(word, { opacity: 0 });
                                   }
                              });
                         } else if (progress < 0.75) {
                              gsap.set(headerSplit.words, { opacity: 0 });
                         } else if (progress > 0.95) {
                              gsap.set(headerSplit.words, { opacity: 1 });
                         }
                    }
               },
          });

          ScrollTrigger.refresh();
     }

     initScrollMasksAnimation();

     window.addEventListener("resize", () => {
          clearTimeout(window.scrollMasksResizeTimeout);
          window.scrollMasksResizeTimeout = setTimeout(() => {
               initScrollMasksAnimation();
          }, 250);
     });
     
     console.log('✅ Scroll Masks Animation initialized');
});

export default {};
